module.exports = __webpack_public_path__ + "static/media/warning.63331564.mp3";